export default __webpack_public_path__ + "static/media/r.4914b169.png";